<template>
  <div class="notifications-wrapper">
    <div
      v-show="error"
      class="alert alert-danger"
    >
      {{ error }}

      <div v-if="errorBag">
        <ul
          v-for="(errors, field) in errorBag"
          :key="field"
        >        
          <li
            v-for="(error, index) in errors"
            :key="index"
          >
            {{ error }}
          </li>
        </ul>
      </div>
    </div>

    <div
      v-show="info"
      class="alert alert-info"
    >
      {{ info }}
    </div>

    <div
      v-show="success"
      class="alert alert-success"
    >
      {{ success }}
    </div>
  </div>
</template>

<script>

import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState('notifications', {
      success: state => state.success,
      error: state => state.error,
      errorBag: state => state.errorBag,
      info: state => state.info,
    })
  }
}
</script>

<style lang="scss" scoped>
    .notifications-wrapper {
        ul {
            margin-bottom: 0;
        }
    }
</style>

